import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import SaveIcon from "@mui/icons-material/Save";
import Color from "../../constants/colors.json";
import Styles from "../../constants/styles.json";
import Language from "../../constants/language_fr.json";
import Company from "../../api/company";
import { setCompany } from "../../redux/actions";
import { useDispatch } from "react-redux";

export default function CompanyOptions({
  companyInfo,
  userInfo,
  expanded,
  setExpanded,
  setSnackBar,
  setActivityIndicator,
}) {
  const dispatch = useDispatch();
  const initialValue = companyInfo?.config?.checkQuantityDiff ?? false;
  const [checkQuantityDiff, setCheckQuantityDiff] = useState(initialValue);

  const handleSave = async () => {
    setActivityIndicator({
      isOpen: true,
      message: Language.appBar.updateCompanyInProgress,
    });
    const { Update } = Company || {};
    const { token } = userInfo;
    const _company = {
      ...companyInfo,
      config: { ...companyInfo.config, checkQuantityDiff },
    };
    const { status } = await Update({ company: _company, token });
    if (status === 200) {
      dispatch(setCompany(_company));
      localStorage.setItem("company", JSON.stringify(_company));
      setSnackBar({
        isOpen: true,
        message: Language.snackBar.updateCompanySuccess,
        status: "success",
      });
    } else {
      setSnackBar({
        isOpen: true,
        message: Language.snackBar.updateCompanyError,
        status: "error",
      });
    }
    setActivityIndicator({ isOpen: false, message: null });
  };

  return (
    <Accordion
      square
      style={{ width: "100%" }}
      expanded={expanded === "companyOptions"}
      onChange={() =>
        expanded === "companyOptions"
          ? setExpanded(null)
          : setExpanded("companyOptions")
      }
    >
      <AccordionSummary style={{ display: "flex", alignItems: "center" }}>
        <TuneIcon style={{ color: Color.green }} />
        <Typography variant="subtitle1" style={{ marginLeft: "5px" }}>
          Options
        </Typography>
      </AccordionSummary>
      <AccordionDetails style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <FormControlLabel
          control={
            <Switch
              checked={checkQuantityDiff}
              onChange={({ target }) => setCheckQuantityDiff(target.checked)}
              color="primary"
            />
          }
          label="Quantité issue des états des lieux"
        />
        <Button
          style={{ ...Styles.button, alignSelf: "flex-start" }}
          variant="contained"
          color="primary"
          disabled={checkQuantityDiff === initialValue}
          onClick={handleSave}
          startIcon={<SaveIcon />}
        >
          {Language.appBar.update}
        </Button>
      </AccordionDetails>
    </Accordion>
  );
}
